<ng-container [formGroup]="form" *ngIf="form; else noForm">
  <common-empty-input
    [label]="label"
    [labelWidth]="labelWidth"
    [control]="control"
    [required]="required"
  >
    <ng-container input>
      <input
        class="{{ inputStyleClass }}"
        type="number"
        [formControlName]="property"
      />
    </ng-container>
  </common-empty-input>
</ng-container>
<ng-template #noForm>
  <common-empty-input
    [label]="label"
    [labelWidth]="labelWidth"
    [control]="control"
    [required]="required"
  >
    <ng-container input>
      <ng-container *ngIf="property; else noProperty">
        <input
          class="{{ inputStyleClass }}"
          type="number"
          [(ngModel)]="item[property]"
        />
      </ng-container>
      <ng-template #noProperty>
        <input
          class="{{ inputStyleClass }}"
          type="number"
          [(ngModel)]="item"
          (input)="onInputChange($event)"
        />
      </ng-template>
    </ng-container>
  </common-empty-input>
</ng-template>
